module.exports = __webpack_public_path__ + "img/black.aaf2e601.png";